<i18n>
{
  "fr": {
    "titleTravelers": "VOYAGEURS",
    "traveler": "Voyageur",
    "lastName": "Nom",
    "firstName": "Prénom",
    "dateBirth": "Date de naissance",
    "addTraveler": "Ajouter un voyageur",
    "required": "Champs requis"
  },
  "en": {
    "titleTravelers": "TRAVELERS",
    "traveler": "Traveler",
    "lastName": "Last Name",
    "firstName": "First Name",
    "dateBirth": "Date of birth",
    "addTraveler": "Add a Traveler",
    "required": "Required"
  }
}
</i18n>

<template>
  <v-container>
    <h2
      class="title-container"
    >
      {{ $t('titleTravelers') }}
    </h2>
    <v-row
      v-for="(item, index) in voyageurs"
      :key="index"
    >
      <p
        style="font-size: 15px; margin-left: 12px; margin-bottom: -18px"
      >
        {{ $t('traveler') }} n°{{ index + 1 }}
        <v-icon
          v-if="nbvoyageurs > 1"
          class="icon-delete"
          @click="removeVoyageur(index)"
        >
          mdi-close
        </v-icon>
      </p>
      <v-container>
        <v-row>
          <v-col
            cols="10"
            md="3"
          >
            <label
              class="title-input"
              :for="'lastNameTraveler' + index"
            >
              {{ $t('lastName') }}
            </label>
            <v-text-field
              :id="'lastNameTraveler' + index"
              v-model="item.lastNameTraveler"
              class="my-0 outward py-0"
              color="primary"
              background-color="primaryLight"
              solo
              flat
              required
              :rules="[value => !!value || 'Champs requis']"
              hide-details
            />
            <span
              v-if="!item.lastNameTraveler && formNotValidate"
              class="error-message"
            >
              {{ $t('required') }}
            </span>
          </v-col>
          <v-col
            cols="10"
            md="3"
          >
            <label
              class="title-input"
              :for="'firstNameTraveler' + index"
            >
              {{ $t('firstName') }}
            </label>
            <v-text-field
              :id="'firstNameTraveler' + index"
              v-model="item.firstNameTraveler"
              class="my-0 outward py-0"
              color="primary"
              background-color="primaryLight"
              solo
              flat
              required
              :rules="[value => !!value || 'Champs requis']"
              hide-details
            />
            <span
              v-if="!item.firstNameTraveler && formNotValidate"
              class="error-message"
            >
              {{ $t('required') }}
            </span>
          </v-col>
          <v-col
            cols="10"
            md="6"
          >
            <label
              class="title-input"
              :for="'birstdayDay' + index"
            >
              {{ $t('dateBirth') }}
            </label>
            <v-row>
              <v-col
                class="pa-0 ml-3"
                cols="8"
                md="3"
              >
                <v-select
                  :id="'birstdayDay' + index"
                  v-model="item.selectedBirstdayDay"
                  :items="birstdayDay"
                  placeholder="Jour"
                  class="my-0 outward py-0"
                  color="primary"
                  background-color="primaryLight"
                  solo
                  flat
                  hide-details
                  required
                  :rules="[value => !!value || 'Champs requis']"
                />
                <span
                  v-if="!item.selectedBirstdayDay && formNotValidate"
                  class="error-message"
                >
                  {{ $t('required') }}
                </span>
              </v-col>
              <v-col
                class="pa-0"
                cols="4"
                md="3"
              >
                <v-select
                  :id="'birstdayMonth' + index"
                  v-model="item.selectedBirstdayMonth"
                  :items="birstdayMonth"
                  placeholder="Mois"
                  class="my-0 outward py-0 px-1"
                  color="primary"
                  background-color="primaryLight"
                  solo
                  flat
                  hide-details
                  required
                  :rules="[value => !!value || 'Champs requis']"
                />
                <span
                  v-if="!item.selectedBirstdayMonth && formNotValidate"
                  class="error-message"
                >
                  {{ $t('required') }}
                </span>
              </v-col>
              <v-col
                class="pa-0"
                cols="4"
                md="3"
              >
                <v-select
                  id="'birstdayYears' + index"
                  v-model="item.selectedBirstdayYears"
                  :items="birstdayYears"
                  placeholder="Année"
                  class="my-0 outward py-0"
                  color="primary"
                  background-color="primaryLight"
                  solo
                  flat
                  hide-details
                  required
                  :rules="[value => !!value || 'Champs requis']"
                />
                <span
                  v-if="!item.selectedBirstdayYears && formNotValidate"
                  class="error-message"
                >
                  {{ $t('required') }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-btn
      class="addTravelerButton"
      @click="addVoyageur"
    >
      <v-icon class="mr-1">
        mdi-account-arrow-up-outline
      </v-icon>
      {{ $t('addTraveler') }}
    </v-btn>
  </v-container>
</template>

<script>
export default {
  props: {
    formNotValidate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    birstdayDay: Array.from({ length: 31 }, (_, index) => String(index + 1)),
    birstdayMonth: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    birstdayYears: Array.from({ length: 91 }, (_, index) => String(new Date().getFullYear() - 90 + index)),
    voyageurs: [
      {
        lastNameTraveler: '',
        firstNameTraveler: '',
        selectedBirstdayDay: null,
        selectedBirstdayMonth: null,
        selectedBirstdayYears: null
      }
    ],
    nbvoyageurs: 1
  }),
  methods: {
    addVoyageur () {
      this.voyageurs.push({
        lastNameTraveler: '',
        firstNameTraveler: '',
        selectedBirstdayDay: null,
        selectedBirstdayMonth: null,
        selectedBirstdayYears: null
      })
      this.nbvoyageurs++
    },
    removeVoyageur (index) {
      this.voyageurs.splice(index, 1)
      this.nbvoyageurs--
    },
    validateNbTravelers () {
      return this.nbvoyageurs
    },
    validateTravelersSection () {
      return this.voyageurs
    }
  }
}

</script>

<style scoped>
.error-message {
  color: red;
  font-size: 14px;
  font-style: italic;
}

.title-container {
  margin-bottom: 20px;
  font-weight: 800;
  color: #006fb9;
}

.title-input {
  color: #006fb9;
  font-size: 18px;
  font-weight: 550;
  opacity: 0.8;
}

.addTravelerButton {
  background-color: #EA4C89 !important;
  color: white;
  font-size: 15px;
  font-weight: bold;
  border-radius: 8px;
  transition: transform .2s;
  text-transform: uppercase;
}

.icon-delete {
  position: absolute;
  margin-top: 0;
  margin-left: 10px;
  color: red;
  align-items: center;
}

</style>
